import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import url from "../services/url";

function CandidateFiles({ files }) {
  
  var binaryData = [];
  binaryData.push(files[1]);
  const data = window.URL.createObjectURL(new Blob(binaryData, {type: "application/pdf"}))
  //Is Token valid (for authentication (do not remove this code ))

  return (
    <Row>
      {files.map((file, k) => (
        <Col md={6} key={k}>
          {/* {file.fieldname === "resume" ? (
            <a
              //download
              href={url("/uploads/") + file.filename}
              className="btn btn-primary mr-2"
              key={k}
            >
              Download Resume
            </a>
          ) : null} */}
          {/* {file.fieldname === "candidatePhoto" ? (
            <img
              src={url("/uploads/") + file.filename}
              className="img-fluid"
              key={k}
              alt="Invalid Candidate Photo Upload"
            />
          ) : null} */}
          {file.fieldname === "candidateVideo" ? (
            <div className="embed-responsive embed-responsive-16by9 bg-dark text-light">
              <video
                controls={true}
                src={url("/uploads/") + file.filename}
                className="embed-responsive-item"
                key={k}
              />
            </div>
          ) : null}
        </Col>
      ))}
      {/* {data && <img src={data} className="img-fluid"
              
              alt="Invalid Candidate Photo Upload" />} */}
    </Row>
  );
}

export default CandidateFiles;

// {files.map((file, k) => {
//   let fileName;
//   switch (file.fieldname) {
//     case "resume":
//       fileName = "Resume";
//       break;
//     case "candidatePhoto":
//       fileName = "Candidate Photo";
//       break;
//     case "candidateVideo":
//       fileName = "Candidate Video";
//       return (
//         <video
//           src={url("/uploads/") + file.filename}
//           key={k}
//           alt="Invalid Candidate"
//         />
//       );
//       break;
//     default:
//       fileName = "Attached File";
//   }
//   return (
//     <img
//       src={url("/uploads/") + file.filename}
//       key={k}
//       alt={"Invalid " + fileName}
//     />
//   );
// })}
